module.exports = "/ios-selectedbe711e2935d892ce48f75d073ea85868.svg";